import 'whatwg-fetch'
import Vue from 'vue'
import App from './App.vue'
import VueI18Next from '@panter/vue-i18next';
import {checkIfShopifyAvailable} from './util/checkIfShopifyAvailable'
import { initSentry } from './util/initSentry';
import { InterfaceLanguage } from './types/types';
import initTranslations from './util/initTranslations';

declare global {
  interface Window { lng: InterfaceLanguage; }
}

initSentry("https://c66b715f717f41ae844cbf5049864bfb@sentry.io/5033488")

Vue.config.productionTip = false
Vue.use(VueI18Next);

const i18n = new VueI18Next(initTranslations());

new Vue({
  render: h => h(App),
  i18n: i18n
}).$mount('#app')

checkIfShopifyAvailable()